import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SignatureType } from 'ngx-mat-esign360';
import { IButtonToggleGroupOption } from '@app/shared/model/button-toggle-group-option.model';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'app-signature-type-select',
  templateUrl: './signature-type-select.component.html',
  styleUrls: ['./signature-type-select.component.scss'],
})
export class SignatureTypeSelectComponent implements OnInit {
  @Input() value: SignatureType;
  @Output() typeSelect = new EventEmitter<SignatureType>();
  options: IButtonToggleGroupOption[] = [
    {
      value: SignatureType.Hand,
      textI18n: marker('SIGNATURE.VERIFY_CODE.HAND'),
      icon: 'edit',
    },
    {
      value: SignatureType.Email,
      textI18n: marker('SIGNATURE.VERIFY_CODE.EMAIL'),
      icon: 'mail_outline',
    },
    {
      value: SignatureType.SMS,
      textI18n: marker('SIGNATURE.VERIFY_CODE.SMS'),
      icon: 'sms',
    },
  ];

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}
}
